import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const Connect = ({ template }) => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.connect.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.connect.paragraph`} />
          </Subtitle>
        </Contentwrapper>
        <ImageWrapper>
          <StyledImage
            src={messages[`${template}.connect.image.src`]}
            alt={messages[`${template}.connect.image.alt`]}
          />
        </ImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

Connect.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Connect;
